import { render, staticRenderFns } from "./ProjectDataForm.vue?vue&type=template&id=82fe57fe&scoped=true&"
import script from "./ProjectDataForm.vue?vue&type=script&lang=js&"
export * from "./ProjectDataForm.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDataForm.vue?vue&type=style&index=0&id=82fe57fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fe57fe",
  null
  
)

export default component.exports